export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/pt-pt.lyaml"));
at({ "pt-pt": { "public": { "sampleString": "String de amostra" } } });
};